import { withI18n } from 'react-i18next';
import TrackingMobileCard from './TrackingMobileCard';

export const pureComponent = TrackingMobileCard;
export default withI18n()(TrackingMobileCard);
